import { useCallback } from "react";
import useSWRMutation from "swr/mutation";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { SearchTimbersResponse, TimberClass } from "./types/timberClass";

const timbersUrl = "/modules/beam_reinforcement/timbers?limit=400";

export const useBeamReinforcementTimbersApi = () => {
  const api = useApi();

  const getBeamReinforcementTimbers = useCallback(
    (signal: AbortSignal) => {
      return useSWRMutation<TimberClass[], CustomError, string>(timbersUrl, (url) =>
        api
          .get<SearchTimbersResponse>({ url, signal })
          .then((response) => response.items.sort((first, second) => first.name.localeCompare(second.name))),
      );
    },
    [api],
  );

  return {
    getBeamReinforcementTimbers,
  };
};

export default useBeamReinforcementTimbersApi;
